<template>
  <div class="mobile:pd-thin pd-medium">
    <SectionPageTitle
      v-if="!MOBILE_APP"
      :title="pageTitle"
      :actions="[
        { method: () => isSettingsPopup = true, label: t('notifications.page.settings') }
      ]"
      class="mn-b-small"
    />

    <NotificationsList />

    <Popup
      :isPopupOpen="isSettingsPopup"
      @close-popup="isSettingsPopup = false"
      :title="t('notifications.page.settingsTitle')"
      class="bg-white pd-medium w-m-30r radius-big"
    >
      <NotificationPreferences />
    </Popup>
  </div>
</template>

<script setup>
import { ref, inject, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SectionPageTitle from '@martyrs/src/modules/core/views/components/sections/SectionPageTitle.vue';
import Popup from '@martyrs/src/design-system/components/Popup/Popup.vue';
import NotificationsList from '../sections/NotificationsList.vue';
import NotificationPreferences from '../sections/NotificationPreferences.vue';

const { t } = useI18n();
const { unreadCount } = inject('useNotifications')();

const isSettingsPopup = ref(false);
const pageTitle = computed(() => {
  const base = t('notifications.page.title');
  return unreadCount.value > 0 ? `${base} (${unreadCount.value})` : base;
});
</script>
